
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"3","height":"13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"_3_dots","data-name":"3 dots","transform":"translate(-1518.724 -121.619)","fill":"#5a677d"}},[_c('circle',{attrs:{"id":"Ellipse_357","data-name":"Ellipse 357","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1518.724 121.619)"}}),_c('circle',{attrs:{"id":"Ellipse_358","data-name":"Ellipse 358","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1518.724 126.619)"}}),_c('circle',{attrs:{"id":"Ellipse_359","data-name":"Ellipse 359","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(1518.724 131.619)"}})])])
          )
        }
      }
    